export const llevarCorreo = ({correo, tema=""}) =>{
    window.open(`mailto:${correo}?subject=${tema}`)
}